export default {
    data() {
        return {
            hasInterestDeduction: this.$isSweden() || this.$isNorway()
        };
    },
    computed: {
        interestCostSweden() {
            return this.getInterestCostSweden(this.amount, this.interestRate, this.duration);
        },
        interestCostAnnuity() {
            return this.getInterestCostAnnuity(this.amount, this.interestRate, this.duration);
        },
        interestCost() {
            if (this.$isSweden()) {
                return this.interestCostSweden;
            }
            return this.interestCostAnnuity;
        },
        interestDeductionPercentage() {
            if (this.$isSweden() || this.$isDenmark()) {
                return 0.3;
            }
            else if (this.$isNorway()) {
                return 0.22;
            }
            return 0;
        },
        interestDeduction() {
            return this.interestCost * -this.interestDeductionPercentage;
        },
        totalCost() {
            return this.interestCost + this.interestDeduction + this.setupFee + this.invoiceFee * this.duration;
        },
        totalPayback() {
            return this.amount + this.totalCost;
        },
        totalMonthlyPayment() {
            return this.totalPayback / this.duration;
        }
    },
    methods: {
        getInterestCostSweden(amount, interestRate, duration) {
            const monthlyInterestRate = (interestRate/100) / 12;
            let currentCost = 0;
            for (let i = duration; i > 0; i--) {
                currentCost += amount * (i/duration) * monthlyInterestRate;
            }
            return currentCost;
        },
        getInterestCostAnnuity(amount, interestRate, duration) {
            const monthlyInterestRate = (interestRate/100) / 12;
            const monthlyPayment = (monthlyInterestRate * amount) / (1 - (1 + monthlyInterestRate) ** -duration);
            const totalInterestCost = (monthlyPayment * duration) - amount;
            return totalInterestCost || 0;
        }
    }
};